import { Serializer } from "./Serializer";
/**
 * Represents the format of the events send to and received from the server.
 */
export class Event {
    get error() {
        return false;
    }
    // MQTT Related
    get topic() {
        return this._raw.destinationName || this._raw.topic;
    }
    get qos() {
        return this._raw.qos;
    } // quality of service
    // PAYLOAD
    get payloadSerialized() {
        return this._raw.payloadString;
    }
    get payload() {
        return this._payload;
    }
    //
    // PAYLOAD Message
    //
    // This is what the consumer of the library actually sends / receives.
    get message() {
        return this._payload ? this._payload.message : undefined;
    }
    //
    // PAYLOAD Metadata
    //
    // The id is used to identify each unique message.
    // That way we know when to resolve the messageSent event.
    get id() {
        return this._payload ? this._payload.id : undefined;
    }
    //
    // The timestamp of the sending of the event.
    get sentAt() {
        return this._payload ? this._payload.sentAt : undefined;
    }
    //
    // The sender EventClient's unique id.
    // That way we know who is the owner of each event and handle it accordingly.
    get senderId() {
        return this._payload ? this._payload.senderId : undefined;
    }
    constructor(args = {}) {
        this._raw = args;
        // args.payload has a value, when the constructor
        // was called to create an Event to be sent.
        this._payload = args.payload;
        // args.payloadString has a value, when the constructor
        // was called on receive of a server event.
        if (!this._payload && !!args.payloadString) {
            this._payload = Serializer.deserialize(args.payloadString);
        }
        // ignored properties
        //
        // args.duplicate
        // args.retained
    }
    toString() {
        return JSON.stringify({
            topic: this.topic,
            qos: this.qos,
            message: this.message,
            id: this.id,
            sentAt: this.sentAt,
            senderId: this.senderId,
            payloadSerialized: this.payloadSerialized,
            _raw: this._raw,
        });
    }
}
